import { getItem, removeItem, setItem } from "utils/safeStorage";

export const INCI_AKU_TRACK_SEED_URL =
  "https://trackseed.ecording.org/?qr=1785231892032563";

const STORAGE_KEY = "inciaku-seed-banner";
const EVENT_NAME = "inciaku-seed-banner-change";

export function isInciAkuSeedBannerVisible() {
  return getItem(STORAGE_KEY) === "1";
}

export function showInciAkuSeedBanner() {
  setItem(STORAGE_KEY, "1");
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function dismissInciAkuSeedBanner() {
  removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function subscribeInciAkuSeedBanner(listener) {
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
